import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import {
  UploadClaimEvidenceInput,
  UploadClaimEvidenceResponse,
  UploadClaimEvidenceVariables,
} from '../types';

const uploadClaimEvidenceFilesMutation = gql`
  mutation PayrollUploadClaimEvidence($input: UploadClaimEvidenceInput!) {
    payrollUploadClaimEvidence(input: $input) {
      code
      success
      message
      file_id
      id
    }
  }
`;

export const uploadClaimEvidenceFiles = (input: UploadClaimEvidenceInput) => {
  return graphQLApi<UploadClaimEvidenceResponse, UploadClaimEvidenceVariables>({
    query: uploadClaimEvidenceFilesMutation,
    queryVariables: { input },
  });
};
